import { all, create } from "mathjs";
import { addDays } from "./CustomFunctions/addDays";
import { addHours } from "./CustomFunctions/addHours";
import { addMinutes } from "./CustomFunctions/addMinutes";
import { addMonths } from "./CustomFunctions/addMonths";
import { author } from "./CustomFunctions/author";
import { averageRows } from "./CustomFunctions/averageRows";
import { countRows } from "./CustomFunctions/countRows";
import { dateDif } from "./CustomFunctions/dateDif";
import { day } from "./CustomFunctions/day";
import { dropColumn } from "./CustomFunctions/dropColumn";
import { EOMonth } from "./CustomFunctions/EOMonth";
import { formatDate } from "./CustomFunctions/formatDate";
import { getDisplayNamesFromPeoplePicker } from "./CustomFunctions/getDisplayNamesFromPeoplePicker";
import { getDisplayNamesFromPeoplePickerInTable } from "./CustomFunctions/getDisplayNamesFromPeoplePickerInTable";
import { getEmailsFromPeoplePicker } from "./CustomFunctions/getEmailsFromPeoplePicker";
import { getHyperlinkFromField } from "./CustomFunctions/getHyperlinkFromField";
import { getHyperlinksFromFieldInTable } from "./CustomFunctions/getHyperlinksFromFieldInTable";
import { hour } from "./CustomFunctions/hour";
import { intercept } from "./CustomFunctions/intercept";
import { join } from "./CustomFunctions/join";
import { minute } from "./CustomFunctions/minute";
import { month } from "./CustomFunctions/month";
import { now } from "./CustomFunctions/now";
import { roundToNextHour } from "./CustomFunctions/roundToNextHour";
import { roundToPreviousHour } from "./CustomFunctions/roundToPreviousHour";
import { slope } from "./CustomFunctions/slope";
import { sumRows } from "./CustomFunctions/sumRows";
import { table } from "./CustomFunctions/table";
import { today } from "./CustomFunctions/today";
import { weekday } from "./CustomFunctions/weekday";

const math = create(all);

math.import({
  author,
  getEmailsFromPeoplePicker,
  getDisplayNamesFromPeoplePicker,
  getDisplayNamesFromPeoplePickerInTable,
  getHyperlinkFromField,
  getHyperlinksFromFieldInTable,
  formatDate,
  now,
  minute,
  hour,
  day,
  month,
  today,
  weekday,
  addMonths,
  addDays,
  addHours,
  addMinutes,
  roundToNextHour,
  roundToPreviousHour,
  dateDif,
  EOMonth,
  join,
  table,
  dropColumn,
  sumRows,
  countRows,
  averageRows,
  slope,
  intercept,
});

export default math;
